<template>
  <modal name="otp-verification" :width="520">
    <div>
      <header class="modal-header center-md center-xs py15 px65 h3 sans-serif weight-700 bg-cl-secondary flex">
        <span>{{ $t('Enter code from SMS') }}</span>
        <i slot="close" class="modal-close material-icons p15 cl-bg-tertiary" @click="close" data-testid="closeModalButton">
          close
        </i>
      </header>
      <div class="modal-content px30 pt0 pb10">
        <div class="my10 px40 py10">
          <base-input v-model="code" name="code" type="text" focus :placeholder="$t('Verification Code *')" />
        </div>
        <button-full class="mb35 button-verify-optv" type="submit" :disabled="!code || submitted" @click.native="verify">
          {{ $t('Verify') }}
        </button-full>
      </div>
    </div>
  </modal>
</template>
<script>
import Modal from 'theme/components/core/Modal'
import ButtonFull from 'theme/components/theme/ButtonFull.vue'

const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput');

export default {
  name: 'OTPVerificationCodeModal',
  components: {
    ButtonFull,
    Modal,
    BaseInput
  },
  data () {
    return {
      code: '',
      submitted: false
    }
  },
  mounted () {
    this.$bus.$on('modal-show', this.onModalShow)
  },
  beforeDestroy () {
    this.$bus.$off('modal-show', this.onModalShow)
  },
  methods: {
    verify () {
      // K2-3073: one submit per prompt; Checkout keeps the loader on while it is checked.
      if (this.submitted || !this.code) {
        return
      }
      this.submitted = true
      this.$bus.$emit('otp-verification-submit', { value: this.code })
      this.close()
    },
    onModalShow (name) {
      if (name === 'otp-verification') {
        this.submitted = false
        this.code = ''
      }
    },
    close () {
      this.$bus.$emit('modal-hide', 'otp-verification')
    }
  }
}
</script>
<style scoped lang="scss">
  .button-verify-optv {
    width: 70% !important;
    margin: 5px auto!important;
  }
</style>
